import { render } from "./LayoutHome.vue?vue&type=template&id=32abf6a4"
import script from "./LayoutHome.vue?vue&type=script&lang=js"
export * from "./LayoutHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/origins-memo/origins-memo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__